<script setup lang="ts">
import { BCol, BRow } from 'bootstrap-vue-next';

import IssuePointsCard from './admin-page/IssuePointsCard.vue';
import IssueRewardsCard from './admin-page/IssueRewardsCard.vue';
import ManageUserCard from './admin-page/ManageUserCard.vue';
import SubmissionsCard from './admin-page/SubmissionsCard.vue';
</script>

<template>
  <div class="mt-2">
    <h1 class="mb-4">Admin</h1>

    <SubmissionsCard />

    <BRow>
      <BCol
        cols="12"
        md="6"
        class="mb-3"
      >
        <IssuePointsCard />
      </BCol>
      <BCol
        cols="12"
        md="6"
        class="mb-3"
      >
        <IssueRewardsCard />
      </BCol>
      <BCol
        cols="12"
        md="6"
        class="mb-3"
      >
        <ManageUserCard />
      </BCol>
    </BRow>
  </div>
</template>
